export default __webpack_public_path__ + "static/media/cloud-reimbursement.28749a0c.png";